import * as THREE from 'three';
import { SASH_DEPTH } from './stackLayout';

export function geometryStatus(model, corner) {
  if (model.runs?.some(run => run.group.userData.pivotDoor)) return {
    // One rotating leaf has no sliding stack, corner junction or screen receiver.
    stackSpreadA: '0', stackSpreadB: '0', cornerMeetingGap: 'none', cornerGlassClear: 'none',
    cornerConnection: 'none', fixedScreenCornerReceivers: '0', fixedCornerUprights: 'none',
  };
  if (model.group.userData.fixed) return {
    stackSpreadA: '0', stackSpreadB: '0',
    cornerMeetingGap: corner ? model.group.userData.cornerMeetingGap.toFixed(4) : 'none',
    cornerGlassClear: corner ? 'false' : 'none',
    cornerConnection: corner ? model.group.userData.cornerConnection : 'none',
    fixedScreenCornerReceivers: '0',
    fixedCornerUprights: corner ? String(model.runs.filter(run => run.group.userData.frameSides.includes('right')).length) : 'none',
  };
  model.group.updateMatrixWorld(true);
  const allBounds = model.runs.map(run => run.group.userData.panelPositions.map(position => {
    // Sash envelopes are the actual 55 mm source profile depth, with each
    // instanced panel's current translation and its run's world orientation.
    const box = new THREE.Box3(
      new THREE.Vector3(position.x - run.panelWidth / 2, .042, position.z - SASH_DEPTH / 2),
      new THREE.Vector3(position.x + run.panelWidth / 2, run.height - .042, position.z + SASH_DEPTH / 2),
    );
    return box.applyMatrix4(run.group.matrixWorld);
  }));
  const spreads = model.runs.map(run => {
    const xs = run.group.userData.panelPositions.map(p => p.x);
    return +(Math.max(...xs) - Math.min(...xs)).toFixed(4);
  });
  let gap = null, clear = null;
  if (corner) {
    const a = allBounds[0].at(-1), b = allBounds[1].at(-1);
    gap = Math.hypot(Math.max(0, a.min.x - b.max.x, b.min.x - a.max.x), Math.max(0, a.min.z - b.max.z, b.min.z - a.max.z));
    const junction = new THREE.Box3(new THREE.Vector3(-.08, .2, -.08), new THREE.Vector3(.08, model.runs[0].height - .2, .08));
    clear = allBounds.flat().every(box => !box.intersectsBox(junction));
  }
  return {
    stackSpreadA: String(spreads[0]), stackSpreadB: String(spreads[1] ?? 0),
    cornerMeetingGap: gap === null ? 'none' : gap.toFixed(4),
    cornerGlassClear: clear === null ? 'none' : String(clear),
    cornerConnection: corner ? 'moving-stile-postless' : 'none',
    fixedScreenCornerReceivers: String(corner ? model.runs.filter(run => run.screen?.root.userData.fixedEndReceiver).length : 0),
  };
}